module.exports = __webpack_public_path__ + "img/5.8ca7d2f5.png";